export default __webpack_public_path__ + "static/media/SARJI_RAO.74bb1fcf.JPG";